import type { RouteLocationNormalized, Router } from 'vue-router'
import { ErrorRouteName, UserClientUnsupportedError } from './routerErrors'
import { ClientType } from '@/generated/api'
import { shouldApplyRouteGuard } from './noRouteGuardsRoutes'
import type { DeviceApi } from '@/libs/deviceApi/deviceApi'
import { valueOrFallback } from '@/libs/result'

const supportedClients = new Set([ClientType.MINI, ClientType.OFA].map((t) => String(t)))

export const buildSupportedBrowserRouteGuard =
  (deviceApi: DeviceApi) => (to: RouteLocationNormalized) => {
    if (!shouldApplyRouteGuard(to)) return

    const userClient = valueOrFallback(deviceApi.getClientNameAsResult(), 'unknown')

    if (!supportedClients.has(userClient)) {
      throw new UserClientUnsupportedError(userClient)
    }
  }

export const onSupportedBrowserRouteError = (router: Router) => async (error: Error) => {
  if (error instanceof UserClientUnsupportedError) {
    await router.push({ name: ErrorRouteName.ErrorClientUnsupported })
  }
}
